import { ISdColDef } from "../../baseColumn/BaseColumnTypes";
import { BaseColumnBuilder } from "../../baseColumn/BaseColumn_builder";
import { ICellRendererParams, ValueGetterParams, ValueSetterParams } from "ag-grid-community";
import { DURATION_COLUMN_CONFIG } from "./DurationColumn_config";
import DurationCellEditor from "../../../../../editors/Duration";

interface IDurationColumnBuilder {}

export class DurationColumnBuilder extends BaseColumnBuilder implements IDurationColumnBuilder {
  constructor(columnOptions?: ISdColDef<any, any>) {
    super({ ...DURATION_COLUMN_CONFIG(), ...columnOptions });
  }

  withCellEditor = () => {
    return this.setColumnOptions({
      cellEditorSelector: () => ({ component: DurationCellEditor, popup: true, popupPosition: "over" }),
      cellEditorPopup: true
    });
  };

  setValueSetter = (callback: (params: ValueSetterParams) => any) => {
    return this.setColumnOptions({
      valueSetter: callback
    });
  };
  setValueGetter = (callback: (params: ValueGetterParams) => any) => {
    return this.setColumnOptions({
      valueGetter: callback
    });
  };

  withCellRenderer = (callback: (params: ICellRendererParams) => any) => {
    return this.setColumnOptions({ cellRenderer: callback });
  };
}
